/** Operatori anagrafica per movimenti/FIR — solo rubrica locale . */
import { useQuery } from "@tanstack/react-query";
import { endpoints, type ContactItem } from "@/api/client";
import type { RentriChoice } from "@/lib/rentriChoices";

export type OperatoreRuolo = "produttore" | "trasportatore" | "destinatario" | "intermediario";

export function contactIdentificativo(c: ContactItem): string {
  return (c.codice_fiscale || c.partita_iva || "").trim();
}

export function contactToChoice(c: ContactItem): RentriChoice {
  const id = contactIdentificativo(c);
  const extra = [id, c.rentri_iscrizione].filter(Boolean).join(" · ");
  return {
    value: id,
    label: c.denominazione,
    description: extra || undefined,
  };
}

export function contactsToChoices(items: ContactItem[]): RentriChoice[] {
  return items
    .filter((c) => contactIdentificativo(c))
    .map(contactToChoice);
}

export function useOperatoriByRole(role: OperatoreRuolo) {
  return useQuery({
    queryKey: ["contacts", role],
    queryFn: () => endpoints.contacts.list({ role }),
    staleTime: 60_000,
  });
}

export function findContactByIdent(
  items: ContactItem[],
  ident: string,
): ContactItem | undefined {
  const n = ident.trim();
  if (!n) return undefined;
  return items.find(
    (c) =>
      (c.codice_fiscale ?? "").trim() === n ||
      (c.partita_iva ?? "").trim() === n,
  );
}
